module.exports = __webpack_public_path__ + "img/Newbie_Shield_01_Classic.3b61cb72.png";